import {
    Grid,
    TextField } from "../../ui";
import React,
    { useEffect,
    useState } from "react";
import SnpButton from "../../global/SnpButton";
import DismissButton from "../../global/DismissButton";
import DialogBox from "../../global/DialogBox";
import {
  BACKDATEALLOWED,
  formatDateInReact,
  formatDateInSnp,
  isEmpty
} from "../../../constants/constant";
import { useDispatch, useSelector } from "react-redux";
import uiUtilInstance from "../../../utilities/uiUtil";
import { updateBillDetails } from "../../../store/billDetailsSlice";
import { getConfigValueByKey } from "../../../utilities/commonUtilities";
import { set } from "lodash";

const DateChangeDialog = ({ showDialog, setShowDialog }) => {
  const { billDetails } = useSelector((state) => state.bill);
  const restoBillConfig = useSelector((state) => state.restoBillConfig);
  const [date, setDate] = useState(uiUtilInstance.getTodayFormattedDate());
  const dispatch = useDispatch();
  const [backDateAllowed, setBackDateAllowed] = useState(false);
  useEffect(() => {
    console.log("restoBillConfig: ", restoBillConfig);

    let isBackDateAllowed = getConfigValueByKey(
      restoBillConfig,
      BACKDATEALLOWED
    );
    console.log("isBackDateAllowed: ", isBackDateAllowed);
    setBackDateAllowed(isBackDateAllowed);
    setDate(
      isEmpty(billDetails.createdAt)
        ? uiUtilInstance.getTodayFormattedDate()
        : billDetails.createdAt
    );
  }, [showDialog]);
  const handleSetDate = (event) => {
    console.log("changed date: ", event);
    console.log("changed date vlue: ", event.target.value);
    
    const formatDateVal = formatDateInSnp(
      event.target.value,
      billDetails.createdAt
    );
    setDate(formatDateVal);
    //printLog("handleSetDate",name,value,formatDateVal);
  };
  const handleDialogClose = () => {
    setShowDialog(false);
  };
  const handleDateChange = () => {
    setShowDialog(false);
    if (backDateAllowed)
      dispatch(updateBillDetails({ ...billDetails, createdAt: date }));
  };
  const dialogDateChangeContent = () => {
    return (
      <>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          spacing={1}
          sx={{ p: 1 }}
        >
          <Grid item xs={12} md={12} sm={12} lg={12}>
            <TextField
              type="date"
              id="createdAt"
              name="createdAt"
              variant="filled"
              size="small"
              disabled={!backDateAllowed}
              label="Enter Previous Date"
              value={formatDateInReact(
                isEmpty(billDetails.createdAt)
                  ? uiUtilInstance.getTodayFormattedDate()
                  : billDetails.createdAt
              )}
              onChange={handleSetDate}
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                inputProps: {
                  min: "2000-01-01",
                  max:formatDateInReact(uiUtilInstance.getTodayFormattedDate()),
                },
              }}
            />
          </Grid>
        </Grid>
      </>
    );
  };

  const dialogDateChangeAction = () => {
    return (
      <>
        {backDateAllowed && (
          <SnpButton
            variant="contained"
            color="primary"
            onClick={handleDateChange}
          >
            Change
          </SnpButton>
        )}
        <DismissButton
          variant="contained"
          color="primary"
          onClick={() => setShowDialog(false)}
        >
          Dismiss
        </DismissButton>
      </>
    );
  };

  return (
    <div>
      <DialogBox
        showDialog={showDialog}
        title=""
        onClose={handleDialogClose}
        dialogContent={dialogDateChangeContent()}
        dialogActions={dialogDateChangeAction()}
      ></DialogBox>
    </div>
  );
};

export default DateChangeDialog;
